import EngagementLetterV2 from './EngagementLetterV2';

// V2-only. The legacy Slate-based engagement-letter editor (DocumentContainer)
// was removed; this now always renders the Plate-based EngagementLetterV2. The
// `editor.engagementLetter.v2` key is retained in visibilityKeys.ts for
// reference/revert but is no longer read.
function EngagementLetter() {
    return <EngagementLetterV2 />;
}

export default EngagementLetter;
